var _defs, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _path11, _path12, _g3, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect, _path27, _path28, _g4, _path29, _rect2, _path30, _path31;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 230.838,
    height: 113.804,
    viewBox: "0 0 230.838 113.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 230.838,
    height: 113.804,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 230.839,
    height: 113.804,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 86.271,
    height: 88.719,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 83.824,
    height: 84.436,
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 34 34"
  }, /*#__PURE__*/React.createElement("image", {
    width: 34,
    height: 34,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAIqADAAQAAAABAAAAIgAAAAAhsoNuAAABTklEQVRYCe2U3Q6DMAiF57KHMHv/Z1t8CyddjlIECo0XLukuRqH8fJ5qp3VdH3f4Pe8AQQwDRJ7EUGQoIhWQ/ksGIv57nicr77MsXRfTlLnQPAAJlgUKgTgAXBlViShQ19FsT88BIAZiKhCSLNtURKiBYdSPr9GfQ+zriCruhRaE4EDqWvQBdGVdkCrzcDCMrLU+soOrKAgfSK25L4HkfgjFBHHk5BB8iBXnOebaBFEqMEjZUkNVvvNgpTgDok7bgtVAK6kVz4Dsn6Nomo2L8p9rgjjfPgbDojF8WMSLdfqV/ezNSkP4UahDtxzEYcsw789URBTJhuRHYqKN7f7HFa/wcxW4KnxNZTxPaXMONRWhEuMO4O8KOp8AWi8pCkMgDgz6qDYKQcVhEEwy1MF2sRkAFKZBUKgB9QCgXzcIGlxlo/fIVfPMPgNESnMbRb4MEGfAcLwZvAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-2",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 34 34"
  }, /*#__PURE__*/React.createElement("image", {
    width: 34,
    height: 34,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAIqADAAQAAAABAAAAIgAAAAAhsoNuAAABo0lEQVRYCe2VXXLCMAyESaeHYLj/2TrcImVD17PZyLYc94GHeIboz5K+yBiWdV1vn7C+PgECDBeIn8Q1EZ/ItztG7Mf9vnD/z/M5df2W0eurzQnh8gxUGiQDMAPUBakAlCPx5i97d0TZ6YzeGgAQgjolmRjf7MqLcG+RzYlYETagRBHVOQlKxIvem0z21rBhTaIhYwDAoq/AvN3xs3o0Mg02UAm9ZR+6Sb1DDI7sRJjsAOqnzknApt6dSggS0CsAGrgNny42xj7qGj/o1aP524lCuhyAtu9DTuTTWju9B7LbLAYBxLWp9IcQwaRL/lmQUuC/lLMgOPfo7OmPYrfWb0n4ZZW3REEdMxvQR1tSiopYK142QgknEpB7Udo1uWuSMUIQS9S3YmNsiXTu9VjzWFCsClKZigKwmUrGIbEI9rYazyqI5bCgStWxHbZ+rETbbP77ItXuPr+kCKkOm2Cud48FCV0QbDKYLQ+PYCnMFg6OOEhLgiAzgAkLqjMLgZzURLR4BmgEgLWHQZgISagzjbUO9CkQLzZjZ6/vTI9U7gXiY/oF9TqaY3mkTyQAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 78.929,
    height: 80.764,
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-3",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("image", {
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAIKADAAQAAAABAAAAIAAAAACPTkDJAAABlElEQVRYCe2VUW7DMAxDm2GHKHb/sw09xdIx7QtYR5aVIkB+aqAgLcsiLSfpNM/z5czxdaa4tD8Gvt+9gp/rdfK9v7fbWw/TtOchbEXdgPM9ZsoGOuLehU0HKkaGBgJhF4W7uPPLyERqoBFHrEW6j3CLqYnqQyhRF4YjLlQMceLtnPiK3Q7Y6SNxj1FMYvwUgy8meldR7YAKIupIfBF55oj/aaEywg4Ep3dRcb6g4gxOLHG4Y/gsHNEBDICYkvhwVA1QVOi8FZCo1kGtp0ZopRJ7A0FfJyaEax0Oekx8MyoG0hNsKm4D6f7qFVCW1rZFmfeQ/RusGqCwWisOUpB1zeEgOSGODHgRF9Wr5vesPHKdh6IeDL8DSih8C9yAtiAcYfgN0KZRB5Sjwekes8dcBjDBuouTm2K3A9rVdEEhF0VccQ03wXyJ9f4HlJS+hrbRi/OpBbXmXHN+0khH9QpUBBM6ORx0kZeYHcJzVp5ewZr1T+w6PNzlI2E2lg2wYWSkKky93QbYeBSmD+FRIlmdj4HTO3AHrRmrfIumi7YAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    clipPath: "url(#clip-path-2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M80.835,48.75a6.3,6.3,0,0,1-3.684,2.164,9.511,9.511,0,0,1-4.9-.53,33.244,33.244,0,0,0,.859-7.521c0-.76-.033-1.509-.082-2.251l.189-.038c2.386-.581,5.252-.905,6.649-1.978.961-.747,1.043-4.51,0-8.523a22.112,22.112,0,0,0-3.391-6.616A6.417,6.417,0,0,1,74.747,27.4a9.533,9.533,0,0,1-4.25,2.488,33.028,33.028,0,0,0-5.287-8.571l.066-.069c1.591-1.892,3.717-3.862,4.227-5.565.347-1.175-1.764-4.273-4.936-6.9A21.542,21.542,0,0,0,58,5.464a6.45,6.45,0,0,1,.89,4.222,9.845,9.845,0,0,1-2.04,4.607,32.011,32.011,0,0,0-9.259-3.643c.2-2.478.775-5.338.2-7.021-.4-1.16-3.9-2.4-7.987-2.631a21.308,21.308,0,0,0-7.245,1.226,6.306,6.306,0,0,1,3.166,2.886,9.957,9.957,0,0,1,1.017,5.015,32,32,0,0,0-9.4,2.644c-1.244-2.093-2.414-4.658-3.814-5.647-1-.7-4.548.38-7.987,2.634a21.826,21.826,0,0,0-5.15,5.313,6.2,6.2,0,0,1,4.229.449A9.684,9.684,0,0,1,18.3,18.909a32.981,32.981,0,0,0-5.925,7.661c-2.218-.953-4.64-2.325-6.345-2.289-1.216.031-3.46,3.024-4.938,6.9A22.219,22.219,0,0,0,0,38.549a6.284,6.284,0,0,1,3.681-2.164,9.535,9.535,0,0,1,4.979.558,33.767,33.767,0,0,0-.53,5.92q0,1.706.166,3.37c-2.353.558-5.127.89-6.5,1.943-.964.747-1.048,4.5,0,8.523A22.053,22.053,0,0,0,5.19,63.314a6.441,6.441,0,0,1,1.726-3.946,9.627,9.627,0,0,1,4.291-2.5A33.276,33.276,0,0,0,16.2,64.6l-.015.018c-1.593,1.892-3.722,3.862-4.232,5.565-.347,1.18,1.767,4.273,4.938,6.9a21.49,21.49,0,0,0,6.57,3.332,6.481,6.481,0,0,1-.892-4.227,9.91,9.91,0,0,1,2.057-4.622A31.966,31.966,0,0,0,33,74.916l-.01.1c-.194,2.478-.775,5.344-.2,7.026.4,1.16,3.9,2.407,7.985,2.631a21.336,21.336,0,0,0,7.245-1.224,6.317,6.317,0,0,1-3.164-2.886,9.817,9.817,0,0,1-1.02-4.89,32.005,32.005,0,0,0,8.859-2.2l.087.163c1.277,2.121,2.47,4.785,3.908,5.8,1,.7,4.551-.382,7.985-2.636a21.826,21.826,0,0,0,5.15-5.313,6.2,6.2,0,0,1-4.229-.444,9.616,9.616,0,0,1-3.641-3.329,32.954,32.954,0,0,0,6.083-7.179l.247.117c2.261.953,4.767,2.4,6.521,2.363,1.211-.033,3.457-3.024,4.933-6.9a22.2,22.2,0,0,0,1.091-7.368",
    transform: "translate(0 1.517)",
    fill: "#cb0f22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M58.908,33.9A26.934,26.934,0,0,1,32.18,61.027,26.934,26.934,0,0,1,5.45,33.9,26.931,26.931,0,0,1,32.18,6.766,26.931,26.931,0,0,1,58.908,33.9",
    transform: "translate(8.444 10.483)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M5.937,33.123A25.677,25.677,0,0,0,31.418,59,25.674,25.674,0,0,0,56.909,33.129,25.679,25.679,0,0,0,31.426,7.26,25.681,25.681,0,0,0,5.937,33.123",
    transform: "translate(9.199 11.249)",
    fill: "#858688"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M20.021,8.553A19.853,19.853,0,0,1,15.174,11.9a5.963,5.963,0,0,0-3.011,2.835,7.958,7.958,0,0,0-.461,3.793A17.927,17.927,0,0,1,15.06,15.64c1.318-.668,3.411-1.927,3.8-2.835s1.16-4.252,1.16-4.252",
    transform: "translate(18.036 13.252)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(8.59)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 86.271,
    height: 88.719,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAkCAYAAAAD3IPhAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAI6ADAAQAAAABAAAAJAAAAAApVL2NAAABj0lEQVRYCe2WAQrCMAxFN/EQ4v3PJrvF9Au//GVJm9YJCitIsuQ3eUs3dV7XdfqVdfkVEHCcMNFpnJOJJnONEq34/XabI81jWYZe0bnn1a4BeGC9UGkYBySazG4qWagmTAPCAimI+lMGqPdtYnPYHn9ybmp3stUH2BTwmqMg47vir8BmOp5AY1UYEbIhrPqQ8JpyACBGEPWpcW14TGYq2IyiI5/S2KlZcnAykyGAbtQYfLs4FcahsTHmis3AUEwAtcixkVruoW2CQOjCyDjRoLaYp4U21dgrGj4znvjbsSNhhifCm3SPicmXRQM9Akm9XQuAa/uxe8JrdzLBV7dtEl3bZtClVmsyLIKCOqFaA4XU/c3fpwwMQWoAbApLGOurxvXdY4IyOCqkCMWmnlUd/NTKTAaF0BDHRBDEoqWa4ldurtT59P8MCnmQBQKCDMi7UOZvp3wjYw+XPtCMbSAQzIJA25wMRFwBFNMb2wPBjV0w3ATrgY0AaM1hGC1ylB++2kc16KlzwkTTOifzF5N5As+eh4UGwCihAAAAAElFTkSuQmCC"
  }))))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M11.707,20.063l-.148-.747a8.262,8.262,0,0,1,.474-4,6.344,6.344,0,0,1,3.22-3.062,19.561,19.561,0,0,0,4.734-3.266l.941-.9-.293,1.27a44.367,44.367,0,0,1-1.18,4.319c-.528,1.229-3.409,2.735-3.982,3.026a17.748,17.748,0,0,0-3.248,2.8Zm7.888-9.693a18.3,18.3,0,0,1-4.025,2.6,5.585,5.585,0,0,0-2.8,2.608,8.7,8.7,0,0,0-.5,2.769A14.311,14.311,0,0,1,15.12,16.01c1.53-.775,3.314-1.93,3.62-2.641a28.607,28.607,0,0,0,.854-3",
    transform: "translate(17.8 12.533)",
    fill: "#100e13"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M12.4,12.416s4.994,4.2,6.356,4.811,4.561,2.126,6.983,1.517,2.764-2.85,5.774-5.264c.785-.63,4.7-1.662,4.7,2.43a2.553,2.553,0,0,1-2.228,2.228,1.914,1.914,0,0,1-1.841-2.529,1.4,1.4,0,0,0,1.5,1.112c1.262-.1,1.178-2.192.1-2.478-1.045-.283-2.815.2-3.98,3.85a12.523,12.523,0,0,1-2.812,5.157l.148.507,3.4.969H17.693l1.259-1.677.874-.1s-4.418-4.755-4.752-5.211-3.5-4.4-3.5-4.4Z",
    transform: "translate(17.942 19.237)",
    fill: "#100e13",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M13.949,17.535H36.741l4.438,1.415H9.585Z",
    transform: "translate(14.85 27.168)",
    fill: "#100e13",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M7.907,24.431h.28a3.184,3.184,0,0,0,.77,1.655,1.681,1.681,0,0,0,1.216.515,1.121,1.121,0,0,0,.946-.357A1.183,1.183,0,0,0,11.4,25.5a1,1,0,0,0-.3-.744,3.861,3.861,0,0,0-.788-.492l-.627-.326a4.15,4.15,0,0,1-1.331-.964,1.823,1.823,0,0,1-.39-1.18,2.237,2.237,0,0,1,.51-1.389,1.9,1.9,0,0,1,1.573-.65,3.222,3.222,0,0,1,1.038.173,3.884,3.884,0,0,0,.579.168A.237.237,0,0,0,11.892,20a.791.791,0,0,0,.1-.26h.291v2.218h-.273a3.115,3.115,0,0,0-.691-1.328,1.54,1.54,0,0,0-1.2-.556,1.088,1.088,0,0,0-.783.28,1.029,1.029,0,0,0-.018,1.4,7.07,7.07,0,0,0,1.191.719l.734.377a2.759,2.759,0,0,1,.775.558,1.951,1.951,0,0,1,.546,1.4,2.219,2.219,0,0,1-.586,1.453,2.31,2.31,0,0,1-1.869.683,3.02,3.02,0,0,1-.6-.059,2.915,2.915,0,0,1-.594-.176l-.189-.074-.127-.033a.579.579,0,0,0-.1-.013.235.235,0,0,0-.214.1.917.917,0,0,0-.1.257h-.28Z",
    transform: "translate(12.251 30.582)",
    fill: "#100e13",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M9.963,26.694v-.26a1.451,1.451,0,0,0,.6-.115.654.654,0,0,0,.275-.6V20.789a.623.623,0,0,0-.288-.6,1.573,1.573,0,0,0-.584-.125v-.252h5.624v2.052h-.242a2.2,2.2,0,0,0-.635-1.349,2.634,2.634,0,0,0-1.616-.362,1.044,1.044,0,0,0-.576.1.48.48,0,0,0-.117.38v2.348a1.457,1.457,0,0,0,1.132-.308,2.473,2.473,0,0,0,.449-1.193h.247v3.442h-.247a2.222,2.222,0,0,0-.428-1.224,1.481,1.481,0,0,0-1.152-.354v2.46a.534.534,0,0,0,.158.441,1.238,1.238,0,0,0,.658.117,2.731,2.731,0,0,0,1.525-.38,3.08,3.08,0,0,0,1.045-1.412h.273l-.4,2.119Z",
    transform: "translate(15.437 30.698)",
    fill: "#100e13",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(11.038 29.369)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 83.824,
    height: 84.436,
    fill: "url(#pattern)"
  }))))))))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M16.176,24.373l-.931-2.358h-.079l-.885,2.358Zm-3.653,2.144a.716.716,0,0,0,.563-.334,4.494,4.494,0,0,0,.393-.854l2.172-5.57h.27L18.1,25.108a7.505,7.505,0,0,0,.548,1.157.58.58,0,0,0,.512.252v.26H16v-.26a2.115,2.115,0,0,0,.622-.087c.1-.041.158-.153.158-.329a1.244,1.244,0,0,0-.079-.359c-.033-.1-.076-.212-.13-.349l-.245-.614h-2.19c-.143.4-.235.665-.275.79a2.089,2.089,0,0,0-.13.563c0,.15.094.257.28.324a1.785,1.785,0,0,0,.5.061v.26H12.523Z",
    transform: "translate(19.403 30.614)",
    fill: "#100e13",
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M15.267,26.434a.948.948,0,0,0,.727-.209.927.927,0,0,0,.163-.607V20.792c0-.28-.061-.461-.189-.548a1.487,1.487,0,0,0-.676-.176v-.255H17.75l1.915,4.709h.087l1.907-4.709h2.455v.255a1.288,1.288,0,0,0-.676.2c-.117.094-.178.339-.178.739v4.5a1.068,1.068,0,0,0,.178.732,1.047,1.047,0,0,0,.676.2v.26H20.881v-.26a1.347,1.347,0,0,0,.65-.15.679.679,0,0,0,.217-.6V20.708h-.066l-2.4,5.986h-.26l-2.417-5.869h-.041v4.607a1.17,1.17,0,0,0,.186.739,1.028,1.028,0,0,0,.8.263v.26H15.267Z",
    transform: "translate(23.654 30.698)",
    fill: "#100e13",
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M18.886,26.694v-.26a1.5,1.5,0,0,0,.6-.115.663.663,0,0,0,.27-.6V20.789a.634.634,0,0,0-.283-.6,1.624,1.624,0,0,0-.591-.125v-.252H24.51v2.052h-.24a2.225,2.225,0,0,0-.63-1.349,2.646,2.646,0,0,0-1.624-.362,1.006,1.006,0,0,0-.569.1c-.079.059-.117.186-.117.38v2.348a1.44,1.44,0,0,0,1.124-.308,2.442,2.442,0,0,0,.454-1.193h.252v3.442h-.252a2.221,2.221,0,0,0-.431-1.224,1.475,1.475,0,0,0-1.147-.354v2.46a.512.512,0,0,0,.161.441,1.2,1.2,0,0,0,.655.117,2.719,2.719,0,0,0,1.519-.38,3.082,3.082,0,0,0,1.048-1.412h.27l-.39,2.119Z",
    transform: "translate(29.262 30.698)",
    fill: "#100e13",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(34.288 29.369)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 83.824,
    height: 84.436,
    fill: "url(#pattern-2)"
  }))))))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M26.476,25.291a7.314,7.314,0,0,0,.214-1.922,5.041,5.041,0,0,0-.469-2.447,1.386,1.386,0,0,0-1.252-.823c-.739,0-1.242.456-1.514,1.379a6.753,6.753,0,0,0-.214,1.892,7.04,7.04,0,0,0,.214,1.922c.273.905.775,1.354,1.514,1.354s1.226-.449,1.507-1.354m.943-4.546a3.606,3.606,0,0,1,1.007,2.623A3.6,3.6,0,0,1,27.419,26a3.523,3.523,0,0,1-5-.1,3.579,3.579,0,0,1-.915-2.475,3.678,3.678,0,0,1,.961-2.626,3.26,3.26,0,0,1,2.506-1.048,3.319,3.319,0,0,1,2.45.994",
    transform: "translate(33.315 30.602)",
    fill: "#100e13",
    fillRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M8.592,17.335l4.023-1.109A2.827,2.827,0,0,1,14.9,17.791a3.693,3.693,0,0,1,.242,1.823L10.92,20.93",
    transform: "translate(13.312 25.14)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M11.1,21.538l-.232-.742,3.972-1.239a3.542,3.542,0,0,0-.242-1.389,2.392,2.392,0,0,0-1.889-1.308L8.759,17.948l-.207-.75,4.092-1.127.071.005a3.2,3.2,0,0,1,2.608,1.813,4.08,4.08,0,0,1,.263,2.029l-.041.232Z",
    transform: "translate(13.25 24.902)",
    fill: "#100e13"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M27.135,17.472,22.671,16.19A2.5,2.5,0,0,0,20.5,17.646a3.705,3.705,0,0,0-.245,1.82l4.212,1.43",
    transform: "translate(31.337 25.085)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M24.576,21.5,20.145,20l-.041-.227a4.124,4.124,0,0,1,.263-2.032A2.875,2.875,0,0,1,22.9,16.036h.059l4.523,1.3-.214.752-4.4-1.262a2.06,2.06,0,0,0-1.767,1.2,3.6,3.6,0,0,0-.24,1.392l3.969,1.349Z",
    transform: "translate(31.1 24.846)",
    fill: "#100e13"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M11.374,20.54a1.8,1.8,0,0,0,1.5-2.078,2.418,2.418,0,0,0-2.516-1.82,2.524,2.524,0,0,0-2.529,2.3c0,1.267,1.02,3,2.381,3H45.67c1.354,0,2.379-1.588,2.379-3A2.591,2.591,0,0,0,43,18.462a1.747,1.747,0,0,0,1.5,2.022",
    transform: "translate(12.132 25.785)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M45.906,22.562H10.447c-1.535,0-2.769-1.851-2.769-3.383a2.922,2.922,0,0,1,2.916-2.69,2.793,2.793,0,0,1,2.9,2.159,2.188,2.188,0,0,1-1.8,2.509l-.173-.76a1.417,1.417,0,0,0,1.2-1.647,2.037,2.037,0,0,0-2.131-1.484,2.143,2.143,0,0,0-2.139,1.912c0,1.15.938,2.605,1.991,2.605H45.906c1.122,0,1.991-1.4,1.991-2.605a2.21,2.21,0,0,0-4.275-.433,1.371,1.371,0,0,0,1.2,1.6l-.176.757a2.128,2.128,0,0,1-1.8-2.453,2.781,2.781,0,0,1,2.906-2.159,2.81,2.81,0,0,1,2.914,2.69c0,1.6-1.183,3.383-2.766,3.383",
    transform: "translate(11.896 25.548)",
    fill: "#100e13"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M22.815,17.572a.281.281,0,1,1-.561,0,.281.281,0,1,1,.561,0",
    transform: "translate(34.48 26.767)",
    fill: "#100e13"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M9.43,17.6a.288.288,0,1,1-.288-.3.294.294,0,0,1,.288.3",
    transform: "translate(13.718 26.797)",
    fill: "#100e13"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M10.55,20.075a3.164,3.164,0,0,1-1.137-.206,1.444,1.444,0,0,1-.959-1.183,1.308,1.308,0,0,1,.5-1.234,1.045,1.045,0,0,1,1.106-.051l-.349.691a.279.279,0,0,0-.311-.005.564.564,0,0,0-.178.5.678.678,0,0,0,.469.553,2.321,2.321,0,0,0,1.1.14l.066-.005h32.2l.033.008a2.25,2.25,0,0,0,.984-.257.669.669,0,0,0,.375-.574.566.566,0,0,0-.143-.489c-.051-.033-.13-.025-.237.028L43.72,17.3a.958.958,0,0,1,1.022.025,1.286,1.286,0,0,1,.479,1.2,1.439,1.439,0,0,1-.834,1.219A2.8,2.8,0,0,1,43,20.057H10.887a2.759,2.759,0,0,1-.337.018",
    transform: "translate(13.083 26.601)",
    fill: "#100e13"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M13.949,17.535H36.741l4.438,1.415H9.585Z",
    transform: "translate(14.85 27.168)",
    fill: "#100e13",
    fillRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M118.214,41.3A38.321,38.321,0,1,1,79.894,2.987,38.319,38.319,0,0,1,118.214,41.3",
    transform: "translate(64.411 4.628)",
    fill: "#e31e1a"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M52.263,16.325l.008,1.438h2.5V24.98h1.573V17.763h2.475l0-1.438Z",
    transform: "translate(80.975 25.294)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M65.164,16.318v.028l-.01-.005-2.593,4.495-2.6-4.495-.01.005v-.028H58.464v8.6h1.489V19.3L61.7,22.327l.862,1.489.857-1.489L65.164,19.3v5.614h1.489v-8.6Z",
    transform: "translate(90.583 25.283)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 5.889,
    height: 1.397,
    transform: "translate(141.46 41.588)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M61.377,20.023v-1.4H56.885V17.16h-1.4v6.488h5.889v-1.4H56.885V20.023Z",
    transform: "translate(85.972 26.588)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M70.15,17.734v-1.4H64.261v8.648H70.15v-1.4H65.658V21.36H70.15v-1.4H65.658V17.734Z",
    transform: "translate(99.565 25.313)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(151.909 22.172)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 78.929,
    height: 80.764,
    fill: "url(#pattern-3)"
  }))))))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M73.995,20.628A4.376,4.376,0,0,0,69.6,16.3H67.216v8.668H69.6v0a4.391,4.391,0,0,0,4.4-4.342M69.574,23.57h-.956V17.7h.966a2.934,2.934,0,1,1-.01,5.866",
    transform: "translate(104.143 25.261)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 4.377,
    height: 1.397,
    transform: "translate(158.319 45.274)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M121.213,12.449l.051.02c.064.036.13.066.191.1-.051-.033-.291-.184-.7-.421A47.494,47.494,0,0,0,100.994,5a32.217,32.217,0,0,0-8.069-.145c-.451.048-.691.087-.691.087h.013A24.365,24.365,0,0,0,89.1,5.6C74.179,9.764,66.712,20.385,61.626,39.964S42.911,58.394,35.765,52.153c.02.023.107.117.257.273l.013.013.018.015c.156.158.375.37.658.617l.013.013A18.068,18.068,0,0,0,50.33,57.129c8.747-1.106,14.911-6.322,19.182-20.155.056-.186.115-.372.171-.563s.117-.377.173-.566c.069-.224.138-.449.209-.676.938-3.072,1.973-6.43,3.309-9.726.061-.15.125-.3.186-.451.046-.115.094-.227.143-.339l.008-.01c3.725-8.683,9.881-16.63,23.235-18.037L97,6.6c.263-.02.648-.048,1.015-.056.117-.005.229-.005.339-.005h.061q.853,0,1.749.048l.023,0c.12.005.242.013.362.02s.257.015.39.025c.214.013.428.031.645.051.178.015.359.031.54.051.135.013.268.028.4.043s.27.028.405.046c.171.02.342.041.515.064.14.018.28.036.423.056l.232.036c.3.043.609.089.918.143.117.018.235.038.357.059.268.046.538.1.813.15.186.033.377.071.566.11l.015,0a41.732,41.732,0,0,1,5.015,1.168l.036.031s.512.171,1.379.484l7.88,3.266.008,0c.122.056.247.112.367.171Zm-.492-.252-.061-.031c-.12-.061-.237-.12-.354-.176l.3.143.018.01q.294.145.459.229c-.12-.056-.237-.115-.357-.176",
    transform: "translate(55.414 7.232)",
    fill: "#ffe600"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M105.608,6.2c-.278-.051-.548-.1-.816-.148l-.357-.061c-.308-.051-.612-.1-.918-.143-.079-.013-.156-.023-.232-.033-.143-.02-.283-.041-.421-.059-.173-.023-.344-.043-.515-.064-.138-.018-.273-.033-.408-.046s-.268-.031-.4-.043c-.181-.02-.362-.036-.54-.051-.217-.02-.431-.036-.645-.051-.127-.01-.26-.018-.39-.025s-.242-.015-.362-.02l-.023,0c-.6-.028-1.175-.046-1.749-.046h-.061c-.11,0-.222,0-.339,0-.367.01-.752.036-1.015.056l-.054.005c-13.354,1.41-19.51,9.354-23.235,18.039-.051.115-.1.232-.148.347-.064.15-.125.3-.189.451-1.341,3.266-2.361,6.608-3.309,9.726-.069.227-.14.451-.206.676-.059.191-.117.38-.173.569s-.117.375-.173.561C64.657,49.669,58.5,54.885,49.749,55.991A18.075,18.075,0,0,1,36.14,51.945a18.938,18.938,0,0,0,1.889,1.463l.025.018a20.671,20.671,0,0,0,1.963,1.183,20.1,20.1,0,0,0,15,1.517l.028-.008c11.059-2.858,15.74-11.227,17.705-17.19a58.886,58.886,0,0,0,2.1-6.758c1.693-6.743,5.915-20.846,18.144-25.147a28.039,28.039,0,0,1,13.178-.716c-.189-.036-.38-.074-.563-.11",
    transform: "translate(55.995 8.371)",
    fill: "#00478f"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.def7cef1fc6b3cd3c43d0a222381f1e7.svg";
export { ForwardRef as ReactComponent };